import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import CategoryList from './pages/CategoryList';
import StickerList from './pages/StickerList';
import StickerForm from './pages/StickerForm';
import StickerUpload from './pages/StickerUpload';
import TemplateList from './pages/TemplateList';

// 路由守卫
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="users" element={<UserList />} />
          <Route path="categories" element={<CategoryList />} />
          <Route path="stickers" element={<StickerList />} />
          <Route path="stickers/upload" element={<StickerUpload />} />
          <Route path="stickers/create" element={<StickerForm />} />
          <Route path="stickers/:id/edit" element={<StickerForm />} />
          <Route path="templates" element={<TemplateList />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
